export default {
	title: 'Warn Notice',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteSuccess: 'Delete successful',
		actionSuccess: 'Operation successful',
		requiredError: 'Required field cannot be empty'
	},
	buttons: {
		add: 'Add',
		batchDelete: 'Batch Delete',
		edit: 'Edit',
		delete: 'Delete',
		pushList: 'Push List'
	},
	table: {
		warnZone: 'Warn Zone',
		warnSensor: 'Warn Sensor',
		warnContent: 'Warn Content',
		warnParameter: 'Warn Parameter',
		warnTime: 'Warn Time',
		pushTime: 'Push Time',
		action: 'Action'
	},
	form: {
		placeholder: {
			sensor: 'Warn Sensor',
			warnCategory: 'Alarm Category'
		},
		label: {
			gearName: 'Gear Name',
			gearBrand: 'Gear Brand',
			bpfo: 'BPFO',
			bpfi: 'BPFI',
			bsf: 'BSF',
			ftf: 'FTF'
		},
		options: {
			warnCategory: {
				alert: 'Alarm',
				offline: 'Offline',
				abnormal: 'Abnormal'
			}
		}
	},
	config: {
		gridLayout: 'Grid Layout'
	},
	dialog: {
		add: 'Add',
		update: 'Edit',
		pushList: 'Push List'
	},
	column: {
		pushType: 'Push Type',
		recipientCode: 'Recipient Code',
		pushResult: 'Push Result'
	}
}
